import { FormDivider } from '@/ui/common/Dividers/FormDivider';
import { WaverezLogo } from '@/ui/common/Icons/WaverezLogo';
import Link from 'next/link';

export const LightboxFooter = () => {
    return (
        <div className="flex h-20 w-full flex-shrink-0 flex-col items-center gap-y-6 px-5 md:h-24 md:px-[60px]">
            <FormDivider className="border border-blue-10 dark:border-blue-1" />
            <p className="tx-large-medium text-gray-2 dark:text-gray-3">
                All prices are in US dollars
            </p>
            <div className="relative flex w-full flex-col items-center pb-6">
                <p className="tx-large-medium z-[2] mb-2 bg-white px-2 text-gray-2 dark:bg-blue-main dark:text-gray-3">
                    Powered By
                </p>
                <Link href="https://www.waverez.com" prefetch={false} data-test-id="waverez-link">
                    <WaverezLogo className="h-6 [&>*:nth-child(1)]:fill-gray-3 [&>*:nth-child(1)]:dark:fill-ash [&>*:nth-child(10)]:fill-gray-3 [&>*:nth-child(10)]:dark:fill-ash [&>*:nth-child(2)]:fill-gray-3 [&>*:nth-child(2)]:dark:fill-ash [&>*:nth-child(7)]:fill-gray-3 [&>*:nth-child(7)]:dark:fill-ash [&>*:nth-child(8)]:fill-gray-3 [&>*:nth-child(8)]:dark:fill-ash [&>*:nth-child(9)]:fill-gray-3 [&>*:nth-child(9)]:dark:fill-ash" />
                </Link>
                <div className="absolute top-[10px] w-full border-b-[2px] border-blue-10 dark:border-blue-1"></div>
            </div>
        </div>
    );
};
